/**
 * This is taken from the ky library. Unfortunately we can't use ky directly
 * for fetching because they only support ES modules, which are difficult to use
 * right now.
 */
export class HTTPError<ResponseBody> extends Error {
  public response: Response;

  public request: Request;

  public responseBody: ResponseBody;

  constructor(response: Response, request: Request, responseBody: ResponseBody) {
    const code = response.status || response.status === 0 ? response.status : '';
    const title = response.statusText || '';
    const status = `${code} ${title}`.trim();
    const reason = status ? `status code ${status}` : 'an unknown error';

    super(`Request failed with ${reason}`);
    Object.setPrototypeOf(this, new.target.prototype);

    this.name = 'HTTPError';
    this.response = response;
    this.request = request;
    this.responseBody = responseBody;
  }

  /**
   * Serializers (JSON.stringify, the Datadog browser SDK) call this instead of
   * walking the fields, so the request headers, the bodies and the query string
   * never leave the browser.
   */
  toJSON(): { name: string; message: string; status: number; method: string; url: string } {
    const { origin, pathname } = new URL(this.request.url);

    return {
      name: this.name,
      message: this.message,
      status: this.response.status,
      method: this.request.method,
      url: `${origin}${pathname}`,
    };
  }
}
